<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'
import { interactionMixin } from 'src/modules/interactions_module.js'
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  props: {
    clickAudioUrl: String
  },
  data() {
    return {
      showIndex: -2, // show first question answers sequentially
      activeItem: null,
      clickAudio: null,
      itemIdToUserAnswerId: {}
    }
  },
  mounted() {
    this.setNextItem(-1);
    // show first question answers sequentially
    Vue.nextTick(() => {
      let interval = setInterval(() => {
        if (!!this.activeItem && this.showIndex == (this.activeItem.answers.length - 1)) {
          clearInterval(interval);
        } else {
          this.showIndex += 1
        }
      }, 500)
    })
  },
  methods: {
    setNextItem(index) {
      const newIndex = index + 1;
      Vue.set(this, 'activeItem', null);
      setTimeout(() => {
        Vue.set(this, 'activeItem', this.items[newIndex]);
      }, 500);
    },
    setUserAnswer(answer) {
      if (!!this.clickAudioUrl && !this.clickAudio) {
        Vue.set(this, 'clickAudio', new Audio(this.clickAudioUrl));
      }
      if (!!this.clickAudio) {
        this.clickAudio.play();
      }
      this.showIndex = this.activeItem.answers.length;
      Vue.set(this.itemIdToUserAnswerId, this.activeItem.$id, answer.$id);
      sendFandomAnalyticsEvent("Interaction Test", this.activeItem.detail, answer.text);
      setTimeout(() => {
        const index = this.items.findIndex(el => el.$id == this.activeItem.$id);
        if (index < (this.items.length - 1)) {
          this.setNextItem(index);
        } else {
          this.updateEvaluateInteraction(
            this.containerContent,
            this.content,
            this.content.interaction,
            this.itemIdToUserAnswerId,
            (data) => {
              Vue.set(this, 'activeItem', null);
              setTimeout(() => {
                this.$emit('interaction-done');
              }, 500)
            }
          );
        }
      }, 300);
    },
    isUserAnswer(answer) {
      return answer.$id == this.itemIdToUserAnswerId[this.activeItem.$id];
    }
  },
  computed: {
    items() {
      return this.content.items;
    }
  }
};
</script>

<template>
  <div
    v-if="isContentVisibleToUser()"
    interaction-evaluate-component
    v-easyadmin="easyadminId"
    class="bg-cover-center"
    :class="contentType"
    :style="{
      'background-image': getContentResponsiveImageURL('background_image'),
      'background-color': content.background_color,
      'text-color': content.text_color || 'white'
    }"
  >
    <div class="container">
      <transition enter-active-class="animated slideInRight faster" leave-active-class="animated slideOutLeft faster">
        <div class="row align-items-center justify-content-center mh-100vh" v-if="activeItem">
          <div class="col-md-8 text-center">
            <div class="text-white mt-2 pt-1" v-if="activeItem.detail">{{activeItem.detail}}</div>
            <h2 class="mb-4 mt-3">{{activeItem.question}}</h2>
            <div class="row">
              <div class="col-md-6 px-5 py-2 p-md-2" v-for="(answer, index) in activeItem.answers" :key="`answer_${answer.$id}_${activeItem.$id}`">
                <transition enter-active-class="animated slideInRight faster">
                  <button
                    v-show="index <= showIndex" 
                    @click="setUserAnswer(answer)"
                    class="btn w-100 px-4 py-3 h-100 btn-answer"
                    :class="isUserAnswer(answer) ? 'btn-light' : 'btn-outline-light'"
                  >
                    <div class="w-100 h-100 d-flex justify-content-center align-items-center">
                      {{answer.text}}
                    </div>
                  </button>
                </transition>
                <!-- trick to make items right positioned while transitioning -->
                <div class="w-100 btn-answer px-4 py-3 placeholder" v-if="index > showIndex">{{answer.text}}</div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[interaction-evaluate-component] {
  overflow: scroll;
  max-height: 100vh;

  .placeholder {
    visibility: hidden;
  }

  .btn-answer {
    min-height: 5rem;
    line-height: 24px;
  }
}
</style>